import React, { ReactNode } from "react";
type Props = {
  children: ReactNode;
};
export default function Header(props: Props): JSX.Element {
  const { children } = props;
  return (
    <div
      className="elementor-element elementor-widget elementor-widget-heading"
      data-element_type="widget"
      data-widget_type="heading.default"
    >
      <div className="elementor-widget-container">
        <h2 className="elementor-heading-title elementor-size-default color-accent">
          {children}
        </h2>
      </div>
    </div>
  );
}
